import { ButtonLoading } from "src/@/components/use/ButtonLoading";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "src/@/components/ui/dialog";
import { Input } from "src/@/components/ui/input";
import { Label } from "src/@/components/ui/label";
import { MultiSelect } from "src/@/components/ui/multi-select";
import { ScrollArea } from "src/@/components/ui/scroll-area";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/@/components/ui/tooltip";
import { HelpCircle } from "lucide-react";

import { DIRECIONAMENTOS_COMPONENT_DESIGN } from "./DirecionamentosComponent.design";

export default function ModalDirecionamentos({
  open,
  onClose,
  onSubmit,
  action,
  recebe,
  changeRecebe,
  changeDepartament,
  changeUser,
  usersSelect,
  users,
  departamentSelect,
  departaments,
  loadingCreate,
  data,
  changeBlock,
  sendMessage,
  changeSendMessage,
  assignAi,
  changeAssignAI,
  prompt,
  changePrompt
}) {

  let departmentsFormatted = departaments?.map((department) => {
    return {
      value: department._id,
      label: department.nome_setor
    }
  });

  let usersFormatted = users?.map((user) => {
    return {
      value: user._id,
      label: user.nomeFantasia
    }
  });

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[605px] p-0 overflow-hidden border-none"
        style={{
          borderRadius: DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.paper.borderRadius,
          boxShadow: DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.paper.boxShadow
        }}
      >
        <DialogHeader className={DIRECIONAMENTOS_COMPONENT_DESIGN.page.header.container + " p-6 pb-2"}>
          <DialogTitle className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.header.sx.color + " text-xl font-bold"}>
            {action === "Criar" ? "Novo direcionamento" : "Editar Direcionamento"}
          </DialogTitle>
        </DialogHeader>

        <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.container}>
          <ScrollArea className="h-[400px] px-2">
            <div className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.content.wrapper + " py-4"}>
              <div>
                <div className="flex items-center gap-1.5 mb-2">
                  <Label className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.content.section.label}>Recebe</Label>
                  <TooltipProvider>
                    <Tooltip delayDuration={300}>
                      <TooltipTrigger asChild>
                        <HelpCircle className="h-3 w-3 text-gray-400 cursor-help" />
                      </TooltipTrigger>
                      <TooltipContent className="max-w-[300px]">
                        <p>Valor enviado pelo cliente e direcionado para os setores e usuários selecionados.</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
                <Input
                  onChange={changeRecebe}
                  value={recebe}
                  className="rounded-xl bg-[#F9FAFB] border-gray-200 focus:border-[#7C3AED] focus:ring-0"
                  placeholder="Ex: Financeiro"
                />
              </div>

              <div>
                <Label className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.content.section.label}>Usuarios</Label>
                <div className="mt-2">
                  <MultiSelect
                    options={usersFormatted}
                    onValueChange={changeUser}
                    defaultValue={usersSelect}
                    placeholder="Selecionar usuarios"
                    variant="inverted"
                    animation={2}
                    maxCount={3}
                  />
                </div>
              </div>

              <div>
                <Label className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.content.section.label}>Setores</Label>
                <div className="mt-2">
                  <MultiSelect
                    options={departmentsFormatted}
                    onValueChange={changeDepartament}
                    defaultValue={departamentSelect}
                    placeholder="Selecionar setores"
                    variant="inverted"
                    animation={2}
                    maxCount={3}
                  />
                </div>
              </div>

            </div>
          </ScrollArea>
        </div>

        <DialogFooter className="p-6 pt-2 bg-white">
          <button
            onClick={onClose}
            className={DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.actions.cancelButton}
          >
            Cancelar
          </button>

          <ButtonLoading
            loading={loadingCreate}
            onClick={onSubmit}
            className={`${DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.actions.confirmButton.base} ${DIRECIONAMENTOS_COMPONENT_DESIGN.dialog.actions.confirmButton.active}`}
          >
            {action === "Criar" ? "Criar" : "Salvar"}
          </ButtonLoading>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
